(function () {
  const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbzrpaMid1EUi6cJcSNsiL15gluMcZAjaGdA-x8D4rDeq3d858pko_MGwqsVsamMe_K7FQ/exec";
  function initSurvey(root) {
    if (!root) return;

    const steps = Array.from(root.querySelectorAll("[data-survey-step]"));
    const progressFill = root.querySelector("[data-survey-progress-fill]");
    const errorEl = root.querySelector("[data-survey-error]");
    const totalQuestionSteps = steps.filter(s => s.dataset.surveyStep !== "done").length;

    const answers = {};
    let currentIndex = 0;

    function showStep(index) {
      steps.forEach((step, i) => { step.hidden = i !== index; });
      currentIndex = index;
      updateProgress();
      if (errorEl) errorEl.hidden = true;
    }

    function updateProgress() {
      if (!progressFill) return;
      const stepName = steps[currentIndex]?.dataset.surveyStep;
      const stepNumber = stepName === "done" ? totalQuestionSteps : currentIndex + 1;
      const pct = Math.min(100, (stepNumber / totalQuestionSteps) * 100);
      progressFill.style.width = pct + "%";
    }

    function goNext() {
      if (currentIndex < steps.length - 1) showStep(currentIndex + 1);
    }

    function goBack() {
      if (currentIndex > 0) showStep(currentIndex - 1);
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    // Single-select option click — auto-advances
    root.addEventListener("click", function (e) {
      const optionBtn = e.target.closest("[data-survey-option]");
      if (!optionBtn) return;

      const step = optionBtn.closest("[data-survey-step]");
      const question = step?.dataset.surveyQuestion;
      if (!question) return;

      answers[question] = optionBtn.dataset.value || optionBtn.textContent.trim();

      step.querySelectorAll("[data-survey-option]").forEach(btn => btn.classList.remove("is-selected"));
      optionBtn.classList.add("is-selected");

      setTimeout(goNext, 250);
    });

    // Back buttons
    root.addEventListener("click", function (e) {
      if (e.target.closest("[data-survey-back]")) goBack();
    });

    // Final submit (email step)
    root.addEventListener("click", function (e) {
      const submitBtn = e.target.closest("[data-survey-submit]");
      if (!submitBtn) return;

      const emailInput = root.querySelector("[data-survey-email-input]");
      const email = emailInput?.value.trim();

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showError("Please enter a valid email address.");
        emailInput?.focus();
        return;
      }

      answers.email = email;
      submitBtn.disabled = true;
      submitBtn.textContent = "Submitting...";

      submitSurvey(answers)
        .then(() => showStep(steps.length - 1))
        .catch(() => {
          submitBtn.disabled = false;
          submitBtn.textContent = "Submit";
          showError("Something went wrong. Please try again.");
        });
    });

    // Enter key submits email step
    root.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && e.target.matches("[data-survey-email-input]")) {
        e.preventDefault();
        root.querySelector("[data-survey-submit]")?.click();
      }
    });

    showStep(0);
  }

  function submitSurvey(data) {
    return fetch(SCRIPT_URL, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify(data)
    }).then(() => true);
  }

  function initAll() {
    document.querySelectorAll("[data-survey]:not([data-survey-initialized])").forEach(function (root) {
      root.setAttribute("data-survey-initialized", "true");
      initSurvey(root);
    });
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll); // re-init when edited live in theme editor
})();